import CorporateIcon from '../components/svg/CorporateIcon';
import EmbededBessIcon from '../components/svg/EmbededBessIcon';
import EnergySharingIcon from '../components/svg/EnergySharingIcon';
import RenewableIcon from '../components/svg/RenewableIcon';
import SypplyIcon from '../components/svg/SupplyIcon';
import UnityScaleIcon from '../components/svg/UnityScaleIcon';

function Start() {
  const serviceTypes = [
    {
      key: 'injection',
      title: 'Request an offtake proposal',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      link: '/services',
      smartDesc: 'smartSteering',
      icon: <SypplyIcon />,
      message: 'Not avalivable right now',
    },
    {
      key: 'offtake',
      title: 'Request an injection proposal',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      link: '/services',
      icon: <RenewableIcon />,
      smartDesc: 'smartSteering',
      message: 'Not avalivable right now',
    },
    {
      key: 'embeddedBESS',
      title: 'Activate battery steering',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      link: '/services',
      icon: <EmbededBessIcon />,
      message: 'Not avalivable right now',
    },
    {
      key: 'energySharing',
      title: 'Visualize my meter data and compare pricing',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      demoCount: null,
      link: '/services',
      icon: <CorporateIcon />,
      message: 'Not avalivable right now',
    },
    {
      key: 'corporatePPA',
      title: 'Create an energy pool',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      demoCount: null,
      link: '/services/corporate-ppa',
      icon: <EnergySharingIcon />,
      message: 'Not avalivable right now',
    },

    {
      key: 'utilityScaleBESS',
      title: 'Simulate local battery investment',
      desc: 'Integer facilisis vel odio ut pellentesque. Nunc non orci ipsum. Ut nec urna justo. Integer facilisis vel odio ut pellentesqu.',
      demoCount: null,
      link: '/services/utility-scale-bess',
      icon: <UnityScaleIcon />,
      message: 'Not avalivable right now',
    },
  ];

  return (
    <div className='  py-[80px] '>
      <h1 className='text-3xl font-semibold text-primary-600 mb-16'>What do you want to do?</h1>
      <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-8'>
        {serviceTypes.map(({ key, title, desc, link, icon }) => (
          <div
            key={key}
            className='p-8 rounded-lg border-[1px] border-base-200 dark:border-primary-800 bg-base-100 dark:bg-primary-900 flex flex-col'
          >
            <div className='mb-4'>{icon}</div>
            <h3 className='font-semibold text-primary-600 dark:text-white text-lg'>{title}</h3>

            <p className='mt-4 text-primary-400 dark:text-primary-300'>{desc}</p>
            <div className='flex items-center mt-6 gap-4'>
              <a
                href={link}
                className='px-[1.25rem] py-[0.53rem] bg-primary-600 text-white rounded-3xl text-sm hover:bg-primary-700 font-semibold flex gap-2'
              >
                Start now
              </a>
              <a
                href='#'
                className='font-semibold hover:text-[#1f2937] text-primary-600 dark:text-white dark:hover:text-primary-200 text-sm'
              >
                learnMore
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Start;
